<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=4000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-container >
            <div v-if="loading">
                <v-row>
                    <v-col>
                        <v-flex align-center>
                            <v-img max-width="700px" src="@/assets/loader.gif"></v-img>
                        </v-flex>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!searchMode && !loading">
            <v-row>
                <v-col>
                    <h1>{{ titrePrincipal }}</h1>
                </v-col>
                <v-col cols="1" v-if="displayedResultSearch">
                    <v-btn color="red" dark @click="closeSearch">Fermer</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="rdvs.length === 0 && loading === false && displayedResultSearch === false">
                <v-col>
                    <v-alert type="info">
                        <h2>Pas de rendez-vous aujourd'hui ...</h2>
                    </v-alert>
                </v-col>
            </v-row>
            <v-row v-if="rdvs.length === 0 && loading === false && displayedResultSearch === true">
                <v-col>
                    <v-alert type="primary">
                        <h2>Pas de résultat à votre recherche</h2>
                    </v-alert>
                </v-col>
            </v-row>
            <div v-for="rdv in rdvs" v-bind:key="rdv.id" class="mt-2">
                <v-row align="center"
                       justify="center"
                       v-bind:class="{
                        'lighten-4': (1 == 1),
                        'blue': (rdv.status === 'termine'),
                        'teal': (rdv.status === 'livre'),
                        'lime': (rdv.status === 'encours'),
                        'orange': (rdv.status === 'nonpresente'),
                    }">
                    <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp">
                        <v-img
                                src="@/assets/icon_termine.png"
                                max-width="200px"
                                min-width="50px"
                                v-if="rdv.status === 'termine'"
                        />
                        <v-img
                                src="@/assets/icon_livre.png"
                                max-width="200px"
                                min-width="50px"
                                v-if="rdv.status === 'livre'"
                        />
                        <v-img
                                src="@/assets/icon_encours.png"
                                max-width="200px"
                                min-width="50px"
                                v-if="rdv.status === 'encours'"
                        />
                        <v-img
                                src="@/assets/icon_nonpresente.png"
                                max-width="200px"
                                min-width="50px"
                                v-if="rdv.status === 'nonpresente'"
                        />
                    </v-col>
                    <v-col>
                        <h4 class="text-left">RDV #{{ rdv.id }} le {{ rdv.date }} à {{ rdv.heure }}</h4>
                        <p class="text-left">
                            {{ rdv.typeintervention }} pour une {{ rdv.modelename }}
                            <br>
                            <strong>Chassis :</strong> {{ rdv.chassis }} - <strong>Matricule :</strong> {{ rdv.matricule }} - <strong>WW :</strong> {{ rdv.clientww }}
                            <br>
                            <strong>Client : </strong> {{ rdv.clientname }} 
                            <br>
                            <strong>Tel : </strong> {{ rdv.clientphone }}
                        </p>
                    </v-col>
                    <v-col>
                        <div class="float-right">
                            <v-switch :disabled="rdv.arrive" label="Client est arrivé" v-model="rdv.arrive" @change="checkArrive(rdv)"></v-switch>
                            <v-switch :disabled="rdv.parti" label="Client est sorti" v-model="rdv.parti" @change="checkParti(rdv)"></v-switch>
                        </div>
                    </v-col>
                </v-row>
            </div>
            </div>
            <div v-if="searchMode && !loading">
                <v-row>
                    <v-col>
                        <h1>Recherche de rendez-vous</h1>
                    </v-col>
                </v-row>
                <v-row class="pl-8 pr-8">
                    <v-text-field v-model="searchText" label="Entrer un numéro de châssis, de rendez-vous ou de plaque d'immatriculation" hide-details="auto"></v-text-field>
                </v-row>
                <v-row class="mt-8">
                    <v-flex justify-center>
                        <v-btn v-if="searchText!=''" x-large color="primary" dark @click="doSearch">Rechercher</v-btn>
                        <v-btn class="ml-6" x-large color="red" dark @click="closeSearch">Fermer</v-btn>
                    </v-flex>
                </v-row>

            </div>
        </v-container>
    </v-app>
</template>

<script>

    import NProgress from "nprogress";

    export default {
        name: 'ListeRdv',
        data() {
            return {
                loading: false,
                snackbar: false,
                errorMsg: '',
                searchText: '',
                displayedResultSearch: false,
                rdvs: [],
                titrePrincipal: 'Rendez-vous du jour',
            }
        },
        computed: {
            sitename() {
                return this.$store.state.user.sitename
            },
            searchMode() {
                return this.$store.state.searchMode
            }
        },
        methods: {
            doSearch(){
                NProgress.start()
                this.loading = true
                let params = {}
                params.action = 'doSearch'
                params.searchText = this.searchText

                this.axios
                    .post(this.$store.state.rootUrl + 'apiv1.php', params, {timeout: 10000})
                    .then(({data}) => {
                        NProgress.done()
                        if (data.error === true) {
                            console.log(data.data)
                            this.errorMsg = 'Impossible d\'effectuer une recherche. Vérifier votre connexion !'
                            this.snackbar = true
                        }
                        this.rdvs = data.data
                        this.displayedResultSearch = true
                        this.titrePrincipal = 'Résultat de recherche pour '+this.searchText
                        this.$store.commit('SET_SEARCH_MODE')
                        this.loading = false
                        this.searchText = ''
                    })
                    .catch((error) => {
                        NProgress.done()
                        console.log(error)
                        this.errorMsg = 'Impossible de contacter le serveur. Vérifier votre connexion !'
                        this.snackbar = true
                        this.loading = false
                        this.searchText = ''
                    })

            },
            closeSearch(){
                this.$store.commit('SET_SEARCH_MODE')
                this.init()
            },
            checkArrive(rdv){
                if(confirm("Confirmez vous l'arrivée de "+rdv.clientname+" ?")) {
                    NProgress.start()
                    this.loading = true
                    let params = {}
                    params.action = 'checkArrive'
                    params.id = rdv.id
                    this.axios
                        .post(this.$store.state.rootUrl + 'apiv1.php', params, {timeout: 10000})
                        .then(({data}) => {
                            NProgress.done()
                            this.loading = false
                            if (data.error === true) {
                                console.log(data.data)
                                this.errorMsg = 'Impossible de changer le statut. Vérifier votre connexion !'
                                this.snackbar = true
                            }
                        })
                        .catch((error) => {
                            NProgress.done()
                            this.loading = false
                            console.log(error)
                            this.errorMsg = 'Impossible de contacter le serveur. Vérifier votre connexion !'
                            this.snackbar = true
                        })
                }else{
                    return false;
                }
            },
            checkParti(rdv){
                if(confirm("Confirmez vous le départ de "+rdv.clientname+" ?")) {
                    NProgress.start()
                    this.loading = true
                    let params = {}
                    params.action = 'checkParti'
                    params.id = rdv.id
                    this.axios
                        .post(this.$store.state.rootUrl + 'apiv1.php', params, {timeout: 10000})
                        .then(({data}) => {
                            NProgress.done()
                            this.loading = false
                            if (data.error === true) {
                                console.log(data.data)
                                this.errorMsg = 'Impossible de changer le statut. Vérifier votre connexion !'
                                this.snackbar = true
                            }
                        })
                        .catch((error) => {
                            NProgress.done()
                            this.loading = false
                            console.log(error)
                            this.errorMsg = 'Impossible de contacter le serveur. Vérifier votre connexion !'
                            this.snackbar = true
                        })
                }else{
                    return false;
                }
            },
            init(){
                NProgress.start()
                this.snackbar = false
                this.errorMsg =  ''
                this.searchText =  ''
                this.displayedResultSearch =  false
                this.rdvs = []
                this.titrePrincipal = 'Rendez-vous du jour '+this.$store.state.user.sitename
                this.loading = true
                let params = {}
                params.action = 'getTodayRdv'
                this.axios
                    .post(this.$store.state.rootUrl+'apiv1.php', params,{timeout: 10000})
                    .then(({ data }) => {
                        console.log(data)
                        if(data.error === false){
                            this.rdvs = data.data
                        }else{
                            this.errorMsg = 'Impossible de contacter le serveur !'
                            this.snackbar = true
                        }
                        NProgress.done()
                        this.loading = false
                    })
                    .catch( error => {
                        console.log(error)
                        NProgress.done()
                        this.loading = false
                    })
            }
        },
        mounted: function () {
            this.init()
        }
    }
</script>
